import { render, staticRenderFns } from "./RoleSync.vue?vue&type=template&id=e65319e6&scoped=true"
import script from "./RoleSync.vue?vue&type=script&lang=js"
export * from "./RoleSync.vue?vue&type=script&lang=js"
import style0 from "./RoleSync.vue?vue&type=style&index=0&id=e65319e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65319e6",
  null
  
)

export default component.exports